export const ENV = process.env.REACT_APP_ENVIRONMENT;
export const BASE_URL = process.env.REACT_APP_BASE_URL || "";
export const API_URL = process.env.REACT_APP_API_URL || "";
export const JSON_URL = process.env.REACT_APP_JSON_URL || "";
export const IMAGES_URL = process.env.REACT_APP_IMAGES_URL || "";
export const GAME_ZONE_URL = process.env.REACT_APP_GZ_LINK || "";
export const FUTURES_URL = process.env.REACT_APP_LINK || "";
export const GZ_API_URL = `${GAME_ZONE_URL}api/`;
export const GZ_JSON_URL = `${GAME_ZONE_URL}json/preseason/`;
export const STORAGE_VERSION = 1;

export const logoLinks = {
	en: "https://cfl.ca/",
	fr: "https://www.lcf.ca/",
};

export const ANSWERS_STORAGE_KEY = "answers";

export const MS_IN_SECOND = 1000;
export const SEC_IN_MINUTE = 60;
export const MIN_IN_HOUR = 60;
export const HRS_IN_DAY = 24;
export const SEC_IN_HOUR = MIN_IN_HOUR * SEC_IN_MINUTE;
export const SEC_IN_DAY = HRS_IN_DAY * SEC_IN_HOUR;
